/*! @pentacode/ui v0.1.0 */
import { formatDay as e, formatPercent as t } from "./charts/format.js";
import { a as n, o as r, t as i, x as a } from "./guide-layout-CrWsmVuf.js";
import { i as o, n as s } from "./theme-BfnA-mmC.js";
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/constant.js
function c(e) {
	return function() {
		return e;
	};
}
//#endregion
//#region ../../node_modules/.pnpm/d3-path@3.1.0/node_modules/d3-path/src/path.js
var l = Math.PI, u = 2 * l, d = 1e-6, f = u - d;
function p(e) {
	this._ += e[0];
	for (let t = 1, n = e.length; t < n; ++t) this._ += arguments[t] + e[t];
}
function m(e) {
	let t = Math.floor(e);
	if (!(t >= 0)) throw Error(`invalid digits: ${e}`);
	if (t > 15) return p;
	let n = 10 ** t;
	return function(e) {
		this._ += e[0];
		for (let t = 1, r = e.length; t < r; ++t) this._ += Math.round(arguments[t] * n) / n + e[t];
	};
}
var h = class {
	constructor(e) {
		this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "", this._append = e == null ? p : m(e);
	}
	moveTo(e, t) {
		this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +t}`;
	}
	closePath() {
		this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
	}
	lineTo(e, t) {
		this._append`L${this._x1 = +e},${this._y1 = +t}`;
	}
	quadraticCurveTo(e, t, n, r) {
		this._append`Q${+e},${+t},${this._x1 = +n},${this._y1 = +r}`;
	}
	bezierCurveTo(e, t, n, r, i, a) {
		this._append`C${+e},${+t},${+n},${+r},${this._x1 = +i},${this._y1 = +a}`;
	}
	arcTo(e, t, n, r, i) {
		if (e = +e, t = +t, n = +n, r = +r, i = +i, i < 0) throw Error(`negative radius: ${i}`);
		let a = this._x1, o = this._y1, s = n - e, c = r - t, u = a - e, f = o - t, p = u * u + f * f;
		if (this._x1 === null) this._append`M${this._x1 = e},${this._y1 = t}`;
		else if (p > d) {
			if (!(Math.abs(f * s - c * u) > d) || !i) this._append`L${this._x1 = e},${this._y1 = t}`;
			else {
				let m = n - a, h = r - o, g = s * s + c * c, _ = m * m + h * h, v = Math.sqrt(g), y = Math.sqrt(p), b = i * Math.tan((l - Math.acos((g + p - _) / (2 * v * y))) / 2), x = b / y, S = b / v;
				Math.abs(x - 1) > d && this._append`L${e + x * u},${t + x * f}`, this._append`A${i},${i},0,0,${+(f * m > u * h)},${this._x1 = e + S * s},${this._y1 = t + S * c}`;
			}
		}
	}
	arc(e, t, n, r, i, a) {
		if (e = +e, t = +t, n = +n, a = !!a, n < 0) throw Error(`negative radius: ${n}`);
		let o = n * Math.cos(r), s = n * Math.sin(r), c = e + o, p = t + s, m = 1 ^ a, h = a ? r - i : i - r;
		this._x1 === null ? this._append`M${c},${p}` : (Math.abs(this._x1 - c) > d || Math.abs(this._y1 - p) > d) && this._append`L${c},${p}`, n && (h < 0 && (h = h % u + u), h > f ? this._append`A${n},${n},0,1,${m},${e - o},${t - s}A${n},${n},0,1,${m},${this._x1 = c},${this._y1 = p}` : h > d && this._append`A${n},${n},0,${+(h >= l)},${m},${this._x1 = e + n * Math.cos(i)},${this._y1 = t + n * Math.sin(i)}`);
	}
	rect(e, t, n, r) {
		this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +t}h${n = +n}v${+r}h${-n}Z`;
	}
	toString() {
		return this._;
	}
};
h.prototype;
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/path.js
function g(e) {
	let t = 3;
	return e.digits = function(n) {
		if (!arguments.length) return t;
		if (n == null) t = null;
		else {
			let e = Math.floor(n);
			if (!(e >= 0)) throw RangeError(`invalid digits: ${n}`);
			t = e;
		}
		return e;
	}, () => new h(t);
}
Array.prototype.slice;
function _(e) {
	return typeof e == "object" && "length" in e ? e : Array.from(e);
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/linear.js
function v(e) {
	this._context = e;
}
v.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._point = 0;
	},
	lineEnd: function() {
		(this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
	},
	point: function(e, t) {
		switch (e = +e, t = +t, this._point) {
			case 0:
				this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
				break;
			case 1: this._point = 2;
			default: this._context.lineTo(e, t);
		}
	}
};
function y(e) {
	return new v(e);
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/point.js
function b(e) {
	return e[0];
}
function x(e) {
	return e[1];
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/line.js
function S(e, t) {
	var n = c(!0), r = null, i = y, a = null, o = g(s);
	e = typeof e == "function" ? e : e === void 0 ? b : c(e), t = typeof t == "function" ? t : t === void 0 ? x : c(t);
	function s(s) {
		var c, l = (s = _(s)).length, u, d = !1, f;
		for (r ?? (a = i(f = o())), c = 0; c <= l; ++c) !(c < l && n(u = s[c], c, s)) === d && ((d = !d) ? a.lineStart() : a.lineEnd()), d && a.point(+e(u, c, s), +t(u, c, s));
		if (f) return a = null, f + "" || null;
	}
	return s.x = function(t) {
		return arguments.length ? (e = typeof t == "function" ? t : c(+t), s) : e;
	}, s.y = function(e) {
		return arguments.length ? (t = typeof e == "function" ? e : c(+e), s) : t;
	}, s.defined = function(e) {
		return arguments.length ? (n = typeof e == "function" ? e : c(!!e), s) : n;
	}, s.curve = function(e) {
		return arguments.length ? (i = e, r != null && (a = i(r)), s) : i;
	}, s.context = function(e) {
		return arguments.length ? (e == null ? r = a = null : a = i(r = e), s) : r;
	}, s;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/area.js
function ee(e, t, n) {
	var r = null, i = c(!0), a = null, o = y, s = null, l = g(u);
	e = typeof e == "function" ? e : e === void 0 ? b : c(+e), t = typeof t == "function" ? t : c(t === void 0 ? 0 : +t), n = typeof n == "function" ? n : n === void 0 ? x : c(+n);
	function u(c) {
		var u, d, f, p = (c = _(c)).length, m, h = !1, g, v = Array(p), y = Array(p);
		for (a ?? (s = o(g = l())), u = 0; u <= p; ++u) {
			if (!(u < p && i(m = c[u], u, c)) === h) {
				if (h = !h) d = u, s.areaStart(), s.lineStart();
				else {
					for (s.lineEnd(), s.lineStart(), f = u - 1; f >= d; --f) s.point(v[f], y[f]);
					s.lineEnd(), s.areaEnd();
				}
			}
			h && (v[u] = +e(m, u, c), y[u] = +t(m, u, c), s.point(r ? +r(m, u, c) : v[u], n ? +n(m, u, c) : y[u]));
		}
		if (g) return s = null, g + "" || null;
	}
	function d() {
		return S().defined(i).curve(o).context(a);
	}
	return u.x = function(t) {
		return arguments.length ? (e = typeof t == "function" ? t : c(+t), r = null, u) : e;
	}, u.x0 = function(t) {
		return arguments.length ? (e = typeof t == "function" ? t : c(+t), u) : e;
	}, u.x1 = function(e) {
		return arguments.length ? (r = e == null ? null : typeof e == "function" ? e : c(+e), u) : r;
	}, u.y = function(e) {
		return arguments.length ? (t = typeof e == "function" ? e : c(+e), n = null, u) : t;
	}, u.y0 = function(e) {
		return arguments.length ? (t = typeof e == "function" ? e : c(+e), u) : t;
	}, u.y1 = function(e) {
		return arguments.length ? (n = e == null ? null : typeof e == "function" ? e : c(+e), u) : n;
	}, u.lineX0 = u.lineY0 = function() {
		return d().x(e).y(t);
	}, u.lineY1 = function() {
		return d().x(e).y(n);
	}, u.lineX1 = function() {
		return d().x(r).y(t);
	}, u.defined = function(e) {
		return arguments.length ? (i = typeof e == "function" ? e : c(!!e), u) : i;
	}, u.curve = function(e) {
		return arguments.length ? (o = e, a != null && (s = o(a)), u) : o;
	}, u.context = function(e) {
		return arguments.length ? (e == null ? a = s = null : s = o(a = e), u) : a;
	}, u;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-shape@3.2.0/node_modules/d3-shape/src/curve/monotone.js
function C(e) {
	return e < 0 ? -1 : 1;
}
function te(e, t, n) {
	var r = e._x1 - e._x0, i = t - e._x1, a = (e._y1 - e._y0) / (r || i < 0 && -0), o = (n - e._y1) / (i || r < 0 && -0), s = (a * i + o * r) / (r + i);
	return (C(a) + C(o)) * Math.min(Math.abs(a), Math.abs(o), .5 * Math.abs(s)) || 0;
}
function ne(e, t) {
	var n = e._x1 - e._x0;
	return n ? (3 * (e._y1 - e._y0) / n - t) / 2 : t;
}
function re(e, t, n) {
	var r = e._x0, i = e._y0, a = e._x1, o = e._y1, s = (a - r) / 3;
	e._context.bezierCurveTo(r + s, i + s * t, a - s, o - s * n, a, o);
}
function w(e) {
	this._context = e;
}
w.prototype = {
	areaStart: function() {
		this._line = 0;
	},
	areaEnd: function() {
		this._line = NaN;
	},
	lineStart: function() {
		this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
	},
	lineEnd: function() {
		switch (this._point) {
			case 2:
				this._context.lineTo(this._x1, this._y1);
				break;
			case 3: re(this, this._t0, ne(this, this._t0));
		}
		(this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
	},
	point: function(e, t) {
		var n = NaN;
		if (e = +e, t = +t, e !== this._x1 || t !== this._y1) {
			switch (this._point) {
				case 0:
					this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
					break;
				case 1:
					this._point = 2;
					break;
				case 2:
					this._point = 3, re(this, ne(this, n = te(this, e, t)), n);
					break;
				default: re(this, this._t0, n = te(this, e, t));
			}
			this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = n;
		}
	}
}, Object.create(w.prototype).point = function(e, t) {
	w.prototype.point.call(this, t, e);
};
function ie(e) {
	return new w(e);
}
//#endregion
//#region ../../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/ascending.js
function T(e, t) {
	return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/descending.js
function ae(e, t) {
	return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bisector.js
function oe(e) {
	let t, n, r;
	e.length === 2 ? (t = e === T || e === ae ? e : se, n = e, r = e) : (t = T, n = (t, n) => T(e(t), n), r = (t, n) => e(t) - n);
	function i(e, r, i = 0, a = e.length) {
		if (i < a) {
			if (t(r, r) !== 0) return a;
			do {
				let t = i + a >>> 1;
				n(e[t], r) < 0 ? i = t + 1 : a = t;
			} while (i < a);
		}
		return i;
	}
	function a(e, r, i = 0, a = e.length) {
		if (i < a) {
			if (t(r, r) !== 0) return a;
			do {
				let t = i + a >>> 1;
				n(e[t], r) <= 0 ? i = t + 1 : a = t;
			} while (i < a);
		}
		return i;
	}
	function o(e, t, n = 0, a = e.length) {
		let o = i(e, t, n, a - 1);
		return o > n && r(e[o - 1], t) > -r(e[o], t) ? o - 1 : o;
	}
	return {
		left: i,
		center: o,
		right: a
	};
}
function se() {
	return 0;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/number.js
function ce(e) {
	return e === null ? NaN : +e;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/bisect.js
var le = oe(T), ue = le.right;
le.left, oe(ce).center;
//#endregion
//#region ../../node_modules/.pnpm/d3-array@3.2.4/node_modules/d3-array/src/ticks.js
var de = Math.sqrt(50), fe = Math.sqrt(10), pe = Math.sqrt(2);
function me(e, t, n) {
	let r = (t - e) / Math.max(0, n), i = Math.floor(Math.log10(r)), a = r / 10 ** i, o = a >= de ? 10 : a >= fe ? 5 : a >= pe ? 2 : 1, s, c, l;
	return i < 0 ? (l = 10 ** -i / o, s = Math.round(e * l), c = Math.round(t * l), s / l < e && ++s, c / l > t && --c, l = -l) : (l = 10 ** i * o, s = Math.round(e / l), c = Math.round(t / l), s * l < e && ++s, c * l > t && --c), c < s && .5 <= n && n < 2 ? me(e, t, n * 2) : [
		s,
		c,
		l
	];
}
function he(e, t, n) {
	return t = +t, e = +e, n = +n, me(e, t, n)[2];
}
function ge(e, t, n) {
	t = +t, e = +e, n = +n;
	let r = t < e, i = r ? he(t, e, n) : he(e, t, n);
	return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
//#endregion
//#region ../../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/init.js
function _e(e, t) {
	switch (arguments.length) {
		case 0: break;
		case 1:
			this.range(e);
			break;
		default: this.range(t).domain(e);
	}
	return this;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/define.js
function ve(e, t, n) {
	e.prototype = t.prototype = n, n.constructor = e;
}
function ye(e, t) {
	var n = Object.create(e.prototype);
	for (var r in t) n[r] = t[r];
	return n;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-color@3.1.0/node_modules/d3-color/src/color.js
function E() {}
var be = .7, xe = 1 / be, D = "\\s*([+-]?\\d+)\\s*", Se = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", O = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Ce = /^#([0-9a-f]{3,8})$/, we = RegExp(`^rgb\\(${D},${D},${D}\\)$`), Te = RegExp(`^rgb\\(${O},${O},${O}\\)$`), Ee = RegExp(`^rgba\\(${D},${D},${D},${Se}\\)$`), De = RegExp(`^rgba\\(${O},${O},${O},${Se}\\)$`), Oe = RegExp(`^hsl\\(${Se},${O},${O}\\)$`), ke = RegExp(`^hsla\\(${Se},${O},${O},${Se}\\)$`), Ae = {
	aliceblue: 15792383,
	antiquewhite: 16444375,
	aqua: 65535,
	aquamarine: 8388564,
	azure: 15794175,
	beige: 16119260,
	bisque: 16770244,
	black: 0,
	blanchedalmond: 16772045,
	blue: 255,
	blueviolet: 9055202,
	brown: 10824234,
	burlywood: 14596231,
	cadetblue: 6266528,
	chartreuse: 8388352,
	chocolate: 13789470,
	coral: 16744272,
	cornflowerblue: 6591981,
	cornsilk: 16775388,
	crimson: 14423100,
	cyan: 65535,
	darkblue: 139,
	darkcyan: 35723,
	darkgoldenrod: 12092939,
	darkgray: 11119017,
	darkgreen: 25600,
	darkgrey: 11119017,
	darkkhaki: 12433259,
	darkmagenta: 9109643,
	darkolivegreen: 5597999,
	darkorange: 16747520,
	darkorchid: 10040012,
	darkred: 9109504,
	darksalmon: 15308410,
	darkseagreen: 9419919,
	darkslateblue: 4734347,
	darkslategray: 3100495,
	darkslategrey: 3100495,
	darkturquoise: 52945,
	darkviolet: 9699539,
	deeppink: 16716947,
	deepskyblue: 49151,
	dimgray: 6908265,
	dimgrey: 6908265,
	dodgerblue: 2003199,
	firebrick: 11674146,
	floralwhite: 16775920,
	forestgreen: 2263842,
	fuchsia: 16711935,
	gainsboro: 14474460,
	ghostwhite: 16316671,
	gold: 16766720,
	goldenrod: 14329120,
	gray: 8421504,
	green: 32768,
	greenyellow: 11403055,
	grey: 8421504,
	honeydew: 15794160,
	hotpink: 16738740,
	indianred: 13458524,
	indigo: 4915330,
	ivory: 16777200,
	khaki: 15787660,
	lavender: 15132410,
	lavenderblush: 16773365,
	lawngreen: 8190976,
	lemonchiffon: 16775885,
	lightblue: 11393254,
	lightcoral: 15761536,
	lightcyan: 14745599,
	lightgoldenrodyellow: 16448210,
	lightgray: 13882323,
	lightgreen: 9498256,
	lightgrey: 13882323,
	lightpink: 16758465,
	lightsalmon: 16752762,
	lightseagreen: 2142890,
	lightskyblue: 8900346,
	lightslategray: 7833753,
	lightslategrey: 7833753,
	lightsteelblue: 11584734,
	lightyellow: 16777184,
	lime: 65280,
	limegreen: 3329330,
	linen: 16445670,
	magenta: 16711935,
	maroon: 8388608,
	mediumaquamarine: 6737322,
	mediumblue: 205,
	mediumorchid: 12211667,
	mediumpurple: 9662683,
	mediumseagreen: 3978097,
	mediumslateblue: 8087790,
	mediumspringgreen: 64154,
	mediumturquoise: 4772300,
	mediumvioletred: 13047173,
	midnightblue: 1644912,
	mintcream: 16121850,
	mistyrose: 16770273,
	moccasin: 16770229,
	navajowhite: 16768685,
	navy: 128,
	oldlace: 16643558,
	olive: 8421376,
	olivedrab: 7048739,
	orange: 16753920,
	orangered: 16729344,
	orchid: 14315734,
	palegoldenrod: 15657130,
	palegreen: 10025880,
	paleturquoise: 11529966,
	palevioletred: 14381203,
	papayawhip: 16773077,
	peachpuff: 16767673,
	peru: 13468991,
	pink: 16761035,
	plum: 14524637,
	powderblue: 11591910,
	purple: 8388736,
	rebeccapurple: 6697881,
	red: 16711680,
	rosybrown: 12357519,
	royalblue: 4286945,
	saddlebrown: 9127187,
	salmon: 16416882,
	sandybrown: 16032864,
	seagreen: 3050327,
	seashell: 16774638,
	sienna: 10506797,
	silver: 12632256,
	skyblue: 8900331,
	slateblue: 6970061,
	slategray: 7372944,
	slategrey: 7372944,
	snow: 16775930,
	springgreen: 65407,
	steelblue: 4620980,
	tan: 13808780,
	teal: 32896,
	thistle: 14204888,
	tomato: 16737095,
	turquoise: 4251856,
	violet: 15631086,
	wheat: 16113331,
	white: 16777215,
	whitesmoke: 16119285,
	yellow: 16776960,
	yellowgreen: 10145074
};
ve(E, k, {
	copy(e) {
		return Object.assign(new this.constructor(), this, e);
	},
	displayable() {
		return this.rgb().displayable();
	},
	hex: je,
	formatHex: je,
	formatHex8: Me,
	formatHsl: Ne,
	formatRgb: Pe,
	toString: Pe
});
function je() {
	return this.rgb().formatHex();
}
function Me() {
	return this.rgb().formatHex8();
}
function Ne() {
	return We(this).formatHsl();
}
function Pe() {
	return this.rgb().formatRgb();
}
function k(e) {
	var t, n;
	return e = (e + "").trim().toLowerCase(), (t = Ce.exec(e)) ? (n = t[1].length, t = parseInt(t[1], 16), n === 6 ? Fe(t) : n === 3 ? new A(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : n === 8 ? Ie(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : n === 4 ? Ie(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = we.exec(e)) ? new A(t[1], t[2], t[3], 1) : (t = Te.exec(e)) ? new A(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Ee.exec(e)) ? Ie(t[1], t[2], t[3], t[4]) : (t = De.exec(e)) ? Ie(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = Oe.exec(e)) ? Ue(t[1], t[2] / 100, t[3] / 100, 1) : (t = ke.exec(e)) ? Ue(t[1], t[2] / 100, t[3] / 100, t[4]) : Ae.hasOwnProperty(e) ? Fe(Ae[e]) : e === "transparent" ? new A(NaN, NaN, NaN, 0) : null;
}
function Fe(e) {
	return new A(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
}
function Ie(e, t, n, r) {
	return r <= 0 && (e = t = n = NaN), new A(e, t, n, r);
}
function Le(e) {
	return e instanceof E || (e = k(e)), e ? (e = e.rgb(), new A(e.r, e.g, e.b, e.opacity)) : new A();
}
function Re(e, t, n, r) {
	return arguments.length === 1 ? Le(e) : new A(e, t, n, r ?? 1);
}
function A(e, t, n, r) {
	this.r = +e, this.g = +t, this.b = +n, this.opacity = +r;
}
ve(A, Re, ye(E, {
	brighter(e) {
		return e = e == null ? xe : xe ** +e, new A(this.r * e, this.g * e, this.b * e, this.opacity);
	},
	darker(e) {
		return e = e == null ? be : be ** +e, new A(this.r * e, this.g * e, this.b * e, this.opacity);
	},
	rgb() {
		return this;
	},
	clamp() {
		return new A(j(this.r), j(this.g), j(this.b), He(this.opacity));
	},
	displayable() {
		return -.5 <= this.r && this.r < 255.5 && -.5 <= this.g && this.g < 255.5 && -.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
	},
	hex: ze,
	formatHex: ze,
	formatHex8: Be,
	formatRgb: Ve,
	toString: Ve
}));
function ze() {
	return `#${M(this.r)}${M(this.g)}${M(this.b)}`;
}
function Be() {
	return `#${M(this.r)}${M(this.g)}${M(this.b)}${M((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Ve() {
	let e = He(this.opacity);
	return `${e === 1 ? "rgb(" : "rgba("}${j(this.r)}, ${j(this.g)}, ${j(this.b)}${e === 1 ? ")" : `, ${e})`}`;
}
function He(e) {
	return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
}
function j(e) {
	return Math.max(0, Math.min(255, Math.round(e) || 0));
}
function M(e) {
	return e = j(e), (e < 16 ? "0" : "") + e.toString(16);
}
function Ue(e, t, n, r) {
	return r <= 0 ? e = t = n = NaN : n <= 0 || n >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new N(e, t, n, r);
}
function We(e) {
	if (e instanceof N) return new N(e.h, e.s, e.l, e.opacity);
	if (e instanceof E || (e = k(e)), !e) return new N();
	if (e instanceof N) return e;
	e = e.rgb();
	var t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.min(t, n, r), a = Math.max(t, n, r), o = NaN, s = a - i, c = (a + i) / 2;
	return s ? (o = t === a ? (n - r) / s + (n < r) * 6 : n === a ? (r - t) / s + 2 : (t - n) / s + 4, s /= c < .5 ? a + i : 2 - a - i, o *= 60) : s = c > 0 && c < 1 ? 0 : o, new N(o, s, c, e.opacity);
}
function Ge(e, t, n, r) {
	return arguments.length === 1 ? We(e) : new N(e, t, n, r ?? 1);
}
function N(e, t, n, r) {
	this.h = +e, this.s = +t, this.l = +n, this.opacity = +r;
}
ve(N, Ge, ye(E, {
	brighter(e) {
		return e = e == null ? xe : xe ** +e, new N(this.h, this.s, this.l * e, this.opacity);
	},
	darker(e) {
		return e = e == null ? be : be ** +e, new N(this.h, this.s, this.l * e, this.opacity);
	},
	rgb() {
		var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < .5 ? n : 1 - n) * t, i = 2 * n - r;
		return new A(Je(e >= 240 ? e - 240 : e + 120, i, r), Je(e, i, r), Je(e < 120 ? e + 240 : e - 120, i, r), this.opacity);
	},
	clamp() {
		return new N(Ke(this.h), qe(this.s), qe(this.l), He(this.opacity));
	},
	displayable() {
		return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
	},
	formatHsl() {
		let e = He(this.opacity);
		return `${e === 1 ? "hsl(" : "hsla("}${Ke(this.h)}, ${qe(this.s) * 100}%, ${qe(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
	}
}));
function Ke(e) {
	return e = (e || 0) % 360, e < 0 ? e + 360 : e;
}
function qe(e) {
	return Math.max(0, Math.min(1, e || 0));
}
function Je(e, t, n) {
	return (e < 60 ? t + (n - t) * e / 60 : e < 180 ? n : e < 240 ? t + (n - t) * (240 - e) / 60 : t) * 255;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/constant.js
var Ye = (e) => () => e;
//#endregion
//#region ../../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/color.js
function Xe(e, t) {
	return function(n) {
		return e + n * t;
	};
}
function Ze(e, t, n) {
	return e **= +n, t = t ** +n - e, n = 1 / n, function(r) {
		return (e + r * t) ** +n;
	};
}
function Qe(e) {
	return (e = +e) == 1 ? $e : function(t, n) {
		return n - t ? Ze(t, n, e) : Ye(isNaN(t) ? n : t);
	};
}
function $e(e, t) {
	var n = t - e;
	return n ? Xe(e, n) : Ye(isNaN(e) ? t : e);
}
//#endregion
//#region ../../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/rgb.js
var et = (function e(t) {
	var n = Qe(t);
	function r(e, t) {
		var r = n((e = Re(e)).r, (t = Re(t)).r), i = n(e.g, t.g), a = n(e.b, t.b), o = $e(e.opacity, t.opacity);
		return function(t) {
			return e.r = r(t), e.g = i(t), e.b = a(t), e.opacity = o(t), e + "";
		};
	}
	return r.gamma = e, r;
})(1);
//#endregion
//#region ../../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/numberArray.js
function tt(e, t) {
	t ||= [];
	var n = e ? Math.min(t.length, e.length) : 0, r = t.slice(), i;
	return function(a) {
		for (i = 0; i < n; ++i) r[i] = e[i] * (1 - a) + t[i] * a;
		return r;
	};
}
function nt(e) {
	return ArrayBuffer.isView(e) && !(e instanceof DataView);
}
//#endregion
//#region ../../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/array.js
function rt(e, t) {
	for (var n = t ? t.length : 0, r = e ? Math.min(n, e.length) : 0, i = Array(r), a = Array(n), o = 0; o < r; ++o) i[o] = ft(e[o], t[o]);
	for (; o < n; ++o) a[o] = t[o];
	return function(e) {
		for (o = 0; o < r; ++o) a[o] = i[o](e);
		return a;
	};
}
//#endregion
//#region ../../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/date.js
function it(e, t) {
	var n = /* @__PURE__ */ new Date();
	return e = +e, t = +t, function(r) {
		return n.setTime(e * (1 - r) + t * r), n;
	};
}
//#endregion
//#region ../../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/number.js
function at(e, t) {
	return e = +e, t = +t, function(n) {
		return e * (1 - n) + t * n;
	};
}
//#endregion
//#region ../../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/object.js
function ot(e, t) {
	var n = {}, r = {}, i;
	for (i in (typeof e != "object" || !e) && (e = {}), (typeof t != "object" || !t) && (t = {}), t) i in e ? n[i] = ft(e[i], t[i]) : r[i] = t[i];
	return function(e) {
		for (i in n) r[i] = n[i](e);
		return r;
	};
}
//#endregion
//#region ../../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/string.js
var st = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, ct = new RegExp(st.source, "g");
function lt(e) {
	return function() {
		return e;
	};
}
function ut(e) {
	return function(t) {
		return e(t) + "";
	};
}
function dt(e, t) {
	var n = st.lastIndex = ct.lastIndex = 0, r, i, a, o = -1, s = [], c = [];
	for (e += "", t += ""; (r = st.exec(e)) && (i = ct.exec(t));) (a = i.index) > n && (a = t.slice(n, a), s[o] ? s[o] += a : s[++o] = a), (r = r[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, c.push({
		i: o,
		x: at(r, i)
	})), n = ct.lastIndex;
	return n < t.length && (a = t.slice(n), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? c[0] ? ut(c[0].x) : lt(t) : (t = c.length, function(e) {
		for (var n = 0, r; n < t; ++n) s[(r = c[n]).i] = r.x(e);
		return s.join("");
	});
}
//#endregion
//#region ../../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/value.js
function ft(e, t) {
	var n = typeof t, r;
	return t == null || n === "boolean" ? Ye(t) : (n === "number" ? at : n === "string" ? (r = k(t)) ? (t = r, et) : dt : t instanceof k ? et : t instanceof Date ? it : nt(t) ? tt : Array.isArray(t) ? rt : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? ot : at)(e, t);
}
//#endregion
//#region ../../node_modules/.pnpm/d3-interpolate@3.0.1/node_modules/d3-interpolate/src/round.js
function pt(e, t) {
	return e = +e, t = +t, function(n) {
		return Math.round(e * (1 - n) + t * n);
	};
}
//#endregion
//#region ../../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/constant.js
function mt(e) {
	return function() {
		return e;
	};
}
//#endregion
//#region ../../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/number.js
function ht(e) {
	return +e;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/continuous.js
var gt = [0, 1];
function P(e) {
	return e;
}
function _t(e, t) {
	return (t -= e = +e) ? function(n) {
		return (n - e) / t;
	} : mt(isNaN(t) ? NaN : .5);
}
function vt(e, t) {
	var n;
	return e > t && (n = e, e = t, t = n), function(n) {
		return Math.max(e, Math.min(t, n));
	};
}
function yt(e, t, n) {
	var r = e[0], i = e[1], a = t[0], o = t[1];
	return i < r ? (r = _t(i, r), a = n(o, a)) : (r = _t(r, i), a = n(a, o)), function(e) {
		return a(r(e));
	};
}
function bt(e, t, n) {
	var r = Math.min(e.length, t.length) - 1, i = Array(r), a = Array(r), o = -1;
	for (e[r] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++o < r;) i[o] = _t(e[o], e[o + 1]), a[o] = n(t[o], t[o + 1]);
	return function(t) {
		var n = ue(e, t, 1, r) - 1;
		return a[n](i[n](t));
	};
}
function xt(e, t) {
	return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
}
function St() {
	var e = gt, t = gt, n = ft, r, i, a, o = P, s, c, l;
	function u() {
		var n = Math.min(e.length, t.length);
		return o !== P && (o = vt(e[0], e[n - 1])), s = n > 2 ? bt : yt, c = l = null, d;
	}
	function d(i) {
		return i == null || isNaN(i = +i) ? a : (c ||= s(e.map(r), t, n))(r(o(i)));
	}
	return d.invert = function(n) {
		return o(i((l ||= s(t, e.map(r), at))(n)));
	}, d.domain = function(t) {
		return arguments.length ? (e = Array.from(t, ht), u()) : e.slice();
	}, d.range = function(e) {
		return arguments.length ? (t = Array.from(e), u()) : t.slice();
	}, d.rangeRound = function(e) {
		return t = Array.from(e), n = pt, u();
	}, d.clamp = function(e) {
		return arguments.length ? (o = e ? !0 : P, u()) : o !== P;
	}, d.interpolate = function(e) {
		return arguments.length ? (n = e, u()) : n;
	}, d.unknown = function(e) {
		return arguments.length ? (a = e, d) : a;
	}, function(e, t) {
		return r = e, i = t, u();
	};
}
function Ct() {
	return St()(P, P);
}
//#endregion
//#region ../../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/nice.js
function wt(e, t) {
	e = e.slice();
	var n = 0, r = e.length - 1, i = e[n], a = e[r], o;
	return a < i && (o = n, n = r, r = o, o = i, i = a, a = o), e[n] = t.floor(i), e[r] = t.ceil(a), e;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/interval.js
var Tt = /* @__PURE__ */ new Date(), Et = /* @__PURE__ */ new Date();
function F(e, t, n, r) {
	function i(t) {
		return e(t = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+t)), t;
	}
	return i.floor = (t) => (e(t = /* @__PURE__ */ new Date(+t)), t), i.ceil = (n) => (e(n = /* @__PURE__ */ new Date(n - 1)), t(n, 1), e(n), n), i.round = (e) => {
		let t = i(e), n = i.ceil(e);
		return e - t < n - e ? t : n;
	}, i.offset = (e, n) => (t(e = /* @__PURE__ */ new Date(+e), n == null ? 1 : Math.floor(n)), e), i.range = (n, r, a) => {
		let o = [];
		if (n = i.ceil(n), a = a == null ? 1 : Math.floor(a), !(n < r) || !(a > 0)) return o;
		let s;
		do
			o.push(s = /* @__PURE__ */ new Date(+n)), t(n, a), e(n);
		while (s < n && n < r);
		return o;
	}, i.filter = (n) => F((t) => {
		if (t >= t) for (; e(t), !n(t);) t.setTime(t - 1);
	}, (e, r) => {
		if (e >= e) {
			if (r < 0) for (; ++r <= 0;) for (; t(e, -1), !n(e););
			else for (; --r >= 0;) for (; t(e, 1), !n(e););
		}
	}), n && (i.count = (t, r) => (Tt.setTime(+t), Et.setTime(+r), e(Tt), e(Et), Math.floor(n(Tt, Et))), i.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? i.filter(r ? (t) => r(t) % e === 0 : (t) => i.count(0, t) % e === 0) : i)), i;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/millisecond.js
var Dt = F(() => {}, (e, t) => {
	e.setTime(+e + t);
}, (e, t) => t - e);
Dt.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? F((t) => {
	t.setTime(Math.floor(t / e) * e);
}, (t, n) => {
	t.setTime(+t + n * e);
}, (t, n) => (n - t) / e) : Dt), Dt.range;
//#endregion
//#region ../../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/duration.js
var I = 1e3, L = I * 60, R = L * 60, z = R * 24, Ot = z * 7, kt = z * 30, At = z * 365, B = F((e) => {
	e.setTime(e - e.getMilliseconds());
}, (e, t) => {
	e.setTime(+e + t * I);
}, (e, t) => (t - e) / I, (e) => e.getUTCSeconds());
B.range;
//#endregion
//#region ../../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/minute.js
var jt = F((e) => {
	e.setTime(e - e.getMilliseconds() - e.getSeconds() * I);
}, (e, t) => {
	e.setTime(+e + t * L);
}, (e, t) => (t - e) / L, (e) => e.getMinutes());
jt.range;
var Mt = F((e) => {
	e.setUTCSeconds(0, 0);
}, (e, t) => {
	e.setTime(+e + t * L);
}, (e, t) => (t - e) / L, (e) => e.getUTCMinutes());
Mt.range;
//#endregion
//#region ../../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/hour.js
var Nt = F((e) => {
	e.setTime(e - e.getMilliseconds() - e.getSeconds() * I - e.getMinutes() * L);
}, (e, t) => {
	e.setTime(+e + t * R);
}, (e, t) => (t - e) / R, (e) => e.getHours());
Nt.range;
var Pt = F((e) => {
	e.setUTCMinutes(0, 0, 0);
}, (e, t) => {
	e.setTime(+e + t * R);
}, (e, t) => (t - e) / R, (e) => e.getUTCHours());
Pt.range;
//#endregion
//#region ../../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/day.js
var Ft = F((e) => e.setHours(0, 0, 0, 0), (e, t) => e.setDate(e.getDate() + t), (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * L) / z, (e) => e.getDate() - 1);
Ft.range;
var It = F((e) => {
	e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
	e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / z, (e) => e.getUTCDate() - 1);
It.range;
var Lt = F((e) => {
	e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
	e.setUTCDate(e.getUTCDate() + t);
}, (e, t) => (t - e) / z, (e) => Math.floor(e / z));
Lt.range;
//#endregion
//#region ../../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/week.js
function V(e) {
	return F((t) => {
		t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
	}, (e, t) => {
		e.setDate(e.getDate() + t * 7);
	}, (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * L) / Ot);
}
var Rt = V(0), zt = V(1), Bt = V(2), Vt = V(3), H = V(4), Ht = V(5), Ut = V(6);
Rt.range, zt.range, Bt.range, Vt.range, H.range, Ht.range, Ut.range;
function U(e) {
	return F((t) => {
		t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
	}, (e, t) => {
		e.setUTCDate(e.getUTCDate() + t * 7);
	}, (e, t) => (t - e) / Ot);
}
var Wt = U(0), Gt = U(1), Kt = U(2), qt = U(3), W = U(4), Jt = U(5), Yt = U(6);
Wt.range, Gt.range, Kt.range, qt.range, W.range, Jt.range, Yt.range;
//#endregion
//#region ../../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/month.js
var Xt = F((e) => {
	e.setDate(1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
	e.setMonth(e.getMonth() + t);
}, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
Xt.range;
var Zt = F((e) => {
	e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
	e.setUTCMonth(e.getUTCMonth() + t);
}, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
Zt.range;
//#endregion
//#region ../../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/year.js
var G = F((e) => {
	e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
	e.setFullYear(e.getFullYear() + t);
}, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
G.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : F((t) => {
	t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
}, (t, n) => {
	t.setFullYear(t.getFullYear() + n * e);
}), G.range;
var K = F((e) => {
	e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
	e.setUTCFullYear(e.getUTCFullYear() + t);
}, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
K.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : F((t) => {
	t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
}, (t, n) => {
	t.setUTCFullYear(t.getUTCFullYear() + n * e);
}), K.range;
//#endregion
//#region ../../node_modules/.pnpm/d3-time@3.1.0/node_modules/d3-time/src/ticks.js
function Qt(e, t, n, r, i, a) {
	let o = [
		[
			B,
			1,
			I
		],
		[
			B,
			5,
			5 * I
		],
		[
			B,
			15,
			15 * I
		],
		[
			B,
			30,
			30 * I
		],
		[
			a,
			1,
			L
		],
		[
			a,
			5,
			5 * L
		],
		[
			a,
			15,
			15 * L
		],
		[
			a,
			30,
			30 * L
		],
		[
			i,
			1,
			R
		],
		[
			i,
			3,
			3 * R
		],
		[
			i,
			6,
			6 * R
		],
		[
			i,
			12,
			12 * R
		],
		[
			r,
			1,
			z
		],
		[
			r,
			2,
			2 * z
		],
		[
			n,
			1,
			Ot
		],
		[
			t,
			1,
			kt
		],
		[
			t,
			3,
			3 * kt
		],
		[
			e,
			1,
			At
		]
	];
	function s(e, t, n) {
		let r = t < e;
		r && ([e, t] = [t, e]);
		let i = n && typeof n.range == "function" ? n : c(e, t, n), a = i ? i.range(e, +t + 1) : [];
		return r ? a.reverse() : a;
	}
	function c(t, n, r) {
		let i = Math.abs(n - t) / r, a = oe(([, , e]) => e).right(o, i);
		if (a === o.length) return e.every(ge(t / At, n / At, r));
		if (a === 0) return Dt.every(Math.max(ge(t, n, r), 1));
		let [s, c] = o[i / o[a - 1][2] < o[a][2] / i ? a - 1 : a];
		return s.every(c);
	}
	return [s, c];
}
var [$t, en] = Qt(K, Zt, Wt, Lt, Pt, Mt), [tn, nn] = Qt(G, Xt, Rt, Ft, Nt, jt);
//#endregion
//#region ../../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/locale.js
function rn(e) {
	if (0 <= e.y && e.y < 100) {
		var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
		return t.setFullYear(e.y), t;
	}
	return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
}
function an(e) {
	if (0 <= e.y && e.y < 100) {
		var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
		return t.setUTCFullYear(e.y), t;
	}
	return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
}
function q(e, t, n) {
	return {
		y: e,
		m: t,
		d: n,
		H: 0,
		M: 0,
		S: 0,
		L: 0
	};
}
function on(e) {
	var t = e.dateTime, n = e.date, r = e.time, i = e.periods, a = e.days, o = e.shortDays, s = e.months, c = e.shortMonths, l = X(i), u = dn(i), d = X(a), f = dn(a), p = X(o), m = dn(o), h = X(s), g = dn(s), _ = X(c), v = dn(c), y = {
		a: se,
		A: ce,
		b: le,
		B: ue,
		c: null,
		d: Mn,
		e: Mn,
		f: Ln,
		g: Jn,
		G: Xn,
		H: Nn,
		I: Pn,
		j: Fn,
		L: In,
		m: Rn,
		M: zn,
		p: de,
		q: fe,
		Q: yr,
		s: br,
		S: Bn,
		u: Vn,
		U: Hn,
		V: Wn,
		w: Gn,
		W: Kn,
		x: null,
		X: null,
		y: qn,
		Y: Yn,
		Z: Zn,
		"%": vr
	}, b = {
		a: pe,
		A: me,
		b: he,
		B: ge,
		c: null,
		d: Qn,
		e: Qn,
		f: rr,
		g: mr,
		G: gr,
		H: $n,
		I: er,
		j: tr,
		L: nr,
		m: ir,
		M: ar,
		p: _e,
		q: ve,
		Q: yr,
		s: br,
		S: or,
		u: sr,
		U: cr,
		V: ur,
		w: dr,
		W: fr,
		x: null,
		X: null,
		y: pr,
		Y: hr,
		Z: _r,
		"%": vr
	}, x = {
		a: ne,
		A: re,
		b: w,
		B: ie,
		c: T,
		d: Sn,
		e: Sn,
		f: On,
		g: vn,
		G: _n,
		H: wn,
		I: wn,
		j: Cn,
		L: Dn,
		m: xn,
		M: Tn,
		p: te,
		q: bn,
		Q: An,
		s: jn,
		S: En,
		u: pn,
		U: mn,
		V: hn,
		w: fn,
		W: gn,
		x: ae,
		X: oe,
		y: vn,
		Y: _n,
		Z: yn,
		"%": kn
	};
	y.x = S(n, y), y.X = S(r, y), y.c = S(t, y), b.x = S(n, b), b.X = S(r, b), b.c = S(t, b);
	function S(e, t) {
		return function(n) {
			var r = [], i = -1, a = 0, o = e.length, s, c, l;
			for (n instanceof Date || (n = /* @__PURE__ */ new Date(+n)); ++i < o;) e.charCodeAt(i) === 37 && (r.push(e.slice(a, i)), (c = sn[s = e.charAt(++i)]) == null ? c = s === "e" ? " " : "0" : s = e.charAt(++i), (l = t[s]) && (s = l(n, c)), r.push(s), a = i + 1);
			return r.push(e.slice(a, i)), r.join("");
		};
	}
	function ee(e, t) {
		return function(n) {
			var r = q(1900, void 0, 1), i = C(r, e, n += "", 0), a, o;
			if (i != n.length) return null;
			if ("Q" in r) return new Date(r.Q);
			if ("s" in r) return new Date(r.s * 1e3 + ("L" in r ? r.L : 0));
			if (t && !("Z" in r) && (r.Z = 0), "p" in r && (r.H = r.H % 12 + r.p * 12), r.m === void 0 && (r.m = "q" in r ? r.q : 0), "V" in r) {
				if (r.V < 1 || r.V > 53) return null;
				"w" in r || (r.w = 1), "Z" in r ? (a = an(q(r.y, 0, 1)), o = a.getUTCDay(), a = o > 4 || o === 0 ? Gt.ceil(a) : Gt(a), a = It.offset(a, (r.V - 1) * 7), r.y = a.getUTCFullYear(), r.m = a.getUTCMonth(), r.d = a.getUTCDate() + (r.w + 6) % 7) : (a = rn(q(r.y, 0, 1)), o = a.getDay(), a = o > 4 || o === 0 ? zt.ceil(a) : zt(a), a = Ft.offset(a, (r.V - 1) * 7), r.y = a.getFullYear(), r.m = a.getMonth(), r.d = a.getDate() + (r.w + 6) % 7);
			} else ("W" in r || "U" in r) && ("w" in r || (r.w = "u" in r ? r.u % 7 : +("W" in r)), o = "Z" in r ? an(q(r.y, 0, 1)).getUTCDay() : rn(q(r.y, 0, 1)).getDay(), r.m = 0, r.d = "W" in r ? (r.w + 6) % 7 + r.W * 7 - (o + 5) % 7 : r.w + r.U * 7 - (o + 6) % 7);
			return "Z" in r ? (r.H += r.Z / 100 | 0, r.M += r.Z % 100, an(r)) : rn(r);
		};
	}
	function C(e, t, n, r) {
		for (var i = 0, a = t.length, o = n.length, s, c; i < a;) {
			if (r >= o) return -1;
			if (s = t.charCodeAt(i++), s === 37) {
				if (s = t.charAt(i++), c = x[s in sn ? t.charAt(i++) : s], !c || (r = c(e, n, r)) < 0) return -1;
			} else if (s != n.charCodeAt(r++)) return -1;
		}
		return r;
	}
	function te(e, t, n) {
		var r = l.exec(t.slice(n));
		return r ? (e.p = u.get(r[0].toLowerCase()), n + r[0].length) : -1;
	}
	function ne(e, t, n) {
		var r = p.exec(t.slice(n));
		return r ? (e.w = m.get(r[0].toLowerCase()), n + r[0].length) : -1;
	}
	function re(e, t, n) {
		var r = d.exec(t.slice(n));
		return r ? (e.w = f.get(r[0].toLowerCase()), n + r[0].length) : -1;
	}
	function w(e, t, n) {
		var r = _.exec(t.slice(n));
		return r ? (e.m = v.get(r[0].toLowerCase()), n + r[0].length) : -1;
	}
	function ie(e, t, n) {
		var r = h.exec(t.slice(n));
		return r ? (e.m = g.get(r[0].toLowerCase()), n + r[0].length) : -1;
	}
	function T(e, n, r) {
		return C(e, t, n, r);
	}
	function ae(e, t, r) {
		return C(e, n, t, r);
	}
	function oe(e, t, n) {
		return C(e, r, t, n);
	}
	function se(e) {
		return o[e.getDay()];
	}
	function ce(e) {
		return a[e.getDay()];
	}
	function le(e) {
		return c[e.getMonth()];
	}
	function ue(e) {
		return s[e.getMonth()];
	}
	function de(e) {
		return i[+(e.getHours() >= 12)];
	}
	function fe(e) {
		return 1 + ~~(e.getMonth() / 3);
	}
	function pe(e) {
		return o[e.getUTCDay()];
	}
	function me(e) {
		return a[e.getUTCDay()];
	}
	function he(e) {
		return c[e.getUTCMonth()];
	}
	function ge(e) {
		return s[e.getUTCMonth()];
	}
	function _e(e) {
		return i[+(e.getUTCHours() >= 12)];
	}
	function ve(e) {
		return 1 + ~~(e.getUTCMonth() / 3);
	}
	return {
		format: function(e) {
			var t = S(e += "", y);
			return t.toString = function() {
				return e;
			}, t;
		},
		parse: function(e) {
			var t = ee(e += "", !1);
			return t.toString = function() {
				return e;
			}, t;
		},
		utcFormat: function(e) {
			var t = S(e += "", b);
			return t.toString = function() {
				return e;
			}, t;
		},
		utcParse: function(e) {
			var t = ee(e += "", !0);
			return t.toString = function() {
				return e;
			}, t;
		}
	};
}
var sn = {
	"-": "",
	_: " ",
	0: "0"
}, J = /^\s*\d+/, cn = /^%/, ln = /[\\^$*+?|[\]().{}]/g;
function Y(e, t, n) {
	var r = e < 0 ? "-" : "", i = (r ? -e : e) + "", a = i.length;
	return r + (a < n ? Array(n - a + 1).join(t) + i : i);
}
function un(e) {
	return e.replace(ln, "\\$&");
}
function X(e) {
	return RegExp("^(?:" + e.map(un).join("|") + ")", "i");
}
function dn(e) {
	return new Map(e.map((e, t) => [e.toLowerCase(), t]));
}
function fn(e, t, n) {
	var r = J.exec(t.slice(n, n + 1));
	return r ? (e.w = +r[0], n + r[0].length) : -1;
}
function pn(e, t, n) {
	var r = J.exec(t.slice(n, n + 1));
	return r ? (e.u = +r[0], n + r[0].length) : -1;
}
function mn(e, t, n) {
	var r = J.exec(t.slice(n, n + 2));
	return r ? (e.U = +r[0], n + r[0].length) : -1;
}
function hn(e, t, n) {
	var r = J.exec(t.slice(n, n + 2));
	return r ? (e.V = +r[0], n + r[0].length) : -1;
}
function gn(e, t, n) {
	var r = J.exec(t.slice(n, n + 2));
	return r ? (e.W = +r[0], n + r[0].length) : -1;
}
function _n(e, t, n) {
	var r = J.exec(t.slice(n, n + 4));
	return r ? (e.y = +r[0], n + r[0].length) : -1;
}
function vn(e, t, n) {
	var r = J.exec(t.slice(n, n + 2));
	return r ? (e.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), n + r[0].length) : -1;
}
function yn(e, t, n) {
	var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(n, n + 6));
	return r ? (e.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), n + r[0].length) : -1;
}
function bn(e, t, n) {
	var r = J.exec(t.slice(n, n + 1));
	return r ? (e.q = r[0] * 3 - 3, n + r[0].length) : -1;
}
function xn(e, t, n) {
	var r = J.exec(t.slice(n, n + 2));
	return r ? (e.m = r[0] - 1, n + r[0].length) : -1;
}
function Sn(e, t, n) {
	var r = J.exec(t.slice(n, n + 2));
	return r ? (e.d = +r[0], n + r[0].length) : -1;
}
function Cn(e, t, n) {
	var r = J.exec(t.slice(n, n + 3));
	return r ? (e.m = 0, e.d = +r[0], n + r[0].length) : -1;
}
function wn(e, t, n) {
	var r = J.exec(t.slice(n, n + 2));
	return r ? (e.H = +r[0], n + r[0].length) : -1;
}
function Tn(e, t, n) {
	var r = J.exec(t.slice(n, n + 2));
	return r ? (e.M = +r[0], n + r[0].length) : -1;
}
function En(e, t, n) {
	var r = J.exec(t.slice(n, n + 2));
	return r ? (e.S = +r[0], n + r[0].length) : -1;
}
function Dn(e, t, n) {
	var r = J.exec(t.slice(n, n + 3));
	return r ? (e.L = +r[0], n + r[0].length) : -1;
}
function On(e, t, n) {
	var r = J.exec(t.slice(n, n + 6));
	return r ? (e.L = Math.floor(r[0] / 1e3), n + r[0].length) : -1;
}
function kn(e, t, n) {
	var r = cn.exec(t.slice(n, n + 1));
	return r ? n + r[0].length : -1;
}
function An(e, t, n) {
	var r = J.exec(t.slice(n));
	return r ? (e.Q = +r[0], n + r[0].length) : -1;
}
function jn(e, t, n) {
	var r = J.exec(t.slice(n));
	return r ? (e.s = +r[0], n + r[0].length) : -1;
}
function Mn(e, t) {
	return Y(e.getDate(), t, 2);
}
function Nn(e, t) {
	return Y(e.getHours(), t, 2);
}
function Pn(e, t) {
	return Y(e.getHours() % 12 || 12, t, 2);
}
function Fn(e, t) {
	return Y(1 + Ft.count(G(e), e), t, 3);
}
function In(e, t) {
	return Y(e.getMilliseconds(), t, 3);
}
function Ln(e, t) {
	return In(e, t) + "000";
}
function Rn(e, t) {
	return Y(e.getMonth() + 1, t, 2);
}
function zn(e, t) {
	return Y(e.getMinutes(), t, 2);
}
function Bn(e, t) {
	return Y(e.getSeconds(), t, 2);
}
function Vn(e) {
	var t = e.getDay();
	return t === 0 ? 7 : t;
}
function Hn(e, t) {
	return Y(Rt.count(G(e) - 1, e), t, 2);
}
function Un(e) {
	var t = e.getDay();
	return t >= 4 || t === 0 ? H(e) : H.ceil(e);
}
function Wn(e, t) {
	return e = Un(e), Y(H.count(G(e), e) + (G(e).getDay() === 4), t, 2);
}
function Gn(e) {
	return e.getDay();
}
function Kn(e, t) {
	return Y(zt.count(G(e) - 1, e), t, 2);
}
function qn(e, t) {
	return Y(e.getFullYear() % 100, t, 2);
}
function Jn(e, t) {
	return e = Un(e), Y(e.getFullYear() % 100, t, 2);
}
function Yn(e, t) {
	return Y(e.getFullYear() % 1e4, t, 4);
}
function Xn(e, t) {
	var n = e.getDay();
	return e = n >= 4 || n === 0 ? H(e) : H.ceil(e), Y(e.getFullYear() % 1e4, t, 4);
}
function Zn(e) {
	var t = e.getTimezoneOffset();
	return (t > 0 ? "-" : (t *= -1, "+")) + Y(t / 60 | 0, "0", 2) + Y(t % 60, "0", 2);
}
function Qn(e, t) {
	return Y(e.getUTCDate(), t, 2);
}
function $n(e, t) {
	return Y(e.getUTCHours(), t, 2);
}
function er(e, t) {
	return Y(e.getUTCHours() % 12 || 12, t, 2);
}
function tr(e, t) {
	return Y(1 + It.count(K(e), e), t, 3);
}
function nr(e, t) {
	return Y(e.getUTCMilliseconds(), t, 3);
}
function rr(e, t) {
	return nr(e, t) + "000";
}
function ir(e, t) {
	return Y(e.getUTCMonth() + 1, t, 2);
}
function ar(e, t) {
	return Y(e.getUTCMinutes(), t, 2);
}
function or(e, t) {
	return Y(e.getUTCSeconds(), t, 2);
}
function sr(e) {
	var t = e.getUTCDay();
	return t === 0 ? 7 : t;
}
function cr(e, t) {
	return Y(Wt.count(K(e) - 1, e), t, 2);
}
function lr(e) {
	var t = e.getUTCDay();
	return t >= 4 || t === 0 ? W(e) : W.ceil(e);
}
function ur(e, t) {
	return e = lr(e), Y(W.count(K(e), e) + (K(e).getUTCDay() === 4), t, 2);
}
function dr(e) {
	return e.getUTCDay();
}
function fr(e, t) {
	return Y(Gt.count(K(e) - 1, e), t, 2);
}
function pr(e, t) {
	return Y(e.getUTCFullYear() % 100, t, 2);
}
function mr(e, t) {
	return e = lr(e), Y(e.getUTCFullYear() % 100, t, 2);
}
function hr(e, t) {
	return Y(e.getUTCFullYear() % 1e4, t, 4);
}
function gr(e, t) {
	var n = e.getUTCDay();
	return e = n >= 4 || n === 0 ? W(e) : W.ceil(e), Y(e.getUTCFullYear() % 1e4, t, 4);
}
function _r() {
	return "+0000";
}
function vr() {
	return "%";
}
function yr(e) {
	return +e;
}
function br(e) {
	return Math.floor(e / 1e3);
}
//#endregion
//#region ../../node_modules/.pnpm/d3-time-format@4.1.0/node_modules/d3-time-format/src/defaultLocale.js
var Z, xr;
Sr({
	dateTime: "%x, %X",
	date: "%-m/%-d/%Y",
	time: "%-I:%M:%S %p",
	periods: ["AM", "PM"],
	days: [
		"Sunday",
		"Monday",
		"Tuesday",
		"Wednesday",
		"Thursday",
		"Friday",
		"Saturday"
	],
	shortDays: [
		"Sun",
		"Mon",
		"Tue",
		"Wed",
		"Thu",
		"Fri",
		"Sat"
	],
	months: [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December"
	],
	shortMonths: [
		"Jan",
		"Feb",
		"Mar",
		"Apr",
		"May",
		"Jun",
		"Jul",
		"Aug",
		"Sep",
		"Oct",
		"Nov",
		"Dec"
	]
});
function Sr(e) {
	return Z = on(e), xr = Z.format, Z.parse, Z.utcFormat, Z.utcParse, Z;
}
//#endregion
//#region ../../node_modules/.pnpm/d3-scale@4.0.2/node_modules/d3-scale/src/time.js
function Cr(e) {
	return new Date(e);
}
function wr(e) {
	return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
}
function Tr(e, t, n, r, i, a, o, s, c, l) {
	var u = Ct(), d = u.invert, f = u.domain, p = l(".%L"), m = l(":%S"), h = l("%I:%M"), g = l("%I %p"), _ = l("%a %d"), v = l("%b %d"), y = l("%B"), b = l("%Y");
	function x(e) {
		return (c(e) < e ? p : s(e) < e ? m : o(e) < e ? h : a(e) < e ? g : r(e) < e ? i(e) < e ? _ : v : n(e) < e ? y : b)(e);
	}
	return u.invert = function(e) {
		return new Date(d(e));
	}, u.domain = function(e) {
		return arguments.length ? f(Array.from(e, wr)) : f().map(Cr);
	}, u.ticks = function(t) {
		var n = f();
		return e(n[0], n[n.length - 1], t ?? 10);
	}, u.tickFormat = function(e, t) {
		return t == null ? x : l(t);
	}, u.nice = function(e) {
		var n = f();
		return (!e || typeof e.range != "function") && (e = t(n[0], n[n.length - 1], e ?? 10)), e ? f(wt(n, e)) : u;
	}, u.copy = function() {
		return xt(u, Tr(e, t, n, r, i, a, o, s, c, l));
	}, u;
}
function Er() {
	return _e.apply(Tr(tn, nn, G, Xt, Rt, Ft, Nt, jt, B, xr).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/d3-shape.js
function Dr(e) {
	let t = S().x((e) => e[0]).y((e) => e[1]).curve(e), n = ee().x((e) => e[0]).y0((e) => e[1]).y1((e) => e[2]).curve(e);
	return {
		line: (e) => t(e) ?? "",
		area: (e, t) => n(e.map((e, n) => [
			e[0],
			t[n]?.[1] ?? e[1],
			e[1]
		])) ?? ""
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/legend-layout-internal.js
function Or(e, t = String) {
	return e.domain.map((n) => ({
		key: a(n),
		value: n,
		label: t(n),
		color: e.map(n)
	}));
}
function kr(e, t, n) {
	let r = Math.max(1, Math.min(e || 1, Math.floor(t / n) || 1));
	return {
		columns: r,
		rows: Math.ceil(e / r),
		itemWidth: t / r
	};
}
function Ar(e, t, n, r) {
	let i = Math.max(0, jr(t)), a = Math.max(0, jr(n)), o = [];
	e.forEach((e, t) => {
		let n = Math.min(i, Math.max(0, jr(e))), r = o.at(-1), s = r ? r.width + a + n : n;
		if (!r || s > i) {
			o.push({
				indexes: [t],
				width: n
			});
			return;
		}
		r.indexes.push(t), r.width = s;
	});
	let s = [];
	return o.forEach((t, n) => {
		let o = r === "center" ? (i - t.width) / 2 : 0;
		t.indexes.forEach((t) => {
			let r = Math.min(i, Math.max(0, jr(e[t])));
			s.push({
				index: t,
				row: n,
				x: o,
				width: r
			}), o += r + a;
		});
	}), {
		rows: o.length,
		items: s
	};
}
function jr(e) {
	return typeof e == "number" && Number.isFinite(e) ? e : 0;
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/legend-static.js
function Mr(e = {}) {
	return (t, r, i, a) => {
		let o = Pr(i, t), s = Ir(e, t, r);
		if (!a) return o.offset + s.rows * s.rowHeight;
		let { bounds: c, theme: l, direction: u } = t, d = [];
		return i && d.push({
			kind: "label",
			key: "legend-label",
			x: c.x,
			y: c.y + o.y,
			text: i,
			anchor: n("left", u),
			fontSize: 11,
			fontWeight: 600,
			style: {
				fill: l.foreground,
				fillOpacity: .78
			}
		}), s.items.forEach(({ item: t, row: r, width: i, x: a }) => {
			let f = c.y + s.firstRowBaseline + o.offset + r * s.rowHeight, p = Math.min(s.indicatorWidth, i), m = Math.min(s.indicatorGap, Math.max(0, i - p)), h = {
				x: c.x + a,
				y: f - s.indicatorHeight / 2,
				width: p,
				height: s.indicatorHeight
			};
			d.push(...Lr(e.indicator, t.value, t.context, h, l.background), {
				kind: "label",
				key: `legend-label:${t.key}`,
				x: h.x + h.width + m - t.textX,
				y: f,
				text: t.label,
				anchor: n("left", u),
				baseline: "middle",
				fontSize: s.fontSize,
				fontWeight: s.fontWeight,
				style: {
					fill: Rr(e.label?.fill, t.value, t.context, l.foreground),
					fillOpacity: e.label?.fillOpacity ?? (e.label?.fill === void 0 ? .76 : 1)
				}
			});
		}), d;
	};
}
function Nr(e = {}) {
	let t = Kr({
		label: e.label,
		width: e.width,
		format: e.format,
		placement: e.placement
	}), r = e.items, i = Math.max(64, e.itemWidth ?? 110);
	return {
		placement: e.placement,
		height(n, a) {
			if (Hr(a.colors.kind)) return t.height(n, a);
			if (r) return 18 + r(a, i, e.label);
			let o = e.label ? 13 : 0, s = kr(n, a.chart.width, i);
			return 18 + o + s.rows * 19;
		},
		render(a) {
			if (Br(a.colors.kind)) return t.render(a);
			if (Vr(a.colors.kind)) return Ur(e, a);
			let { bounds: o, theme: s, direction: c } = a, l = [];
			if (r) l.push(...r(a, i, e.label, !0));
			else {
				let t = e.label ? 13 : 0;
				e.label && l.push({
					kind: "label",
					key: "legend-label",
					x: o.x,
					y: o.y + 11,
					text: e.label,
					anchor: n("left", c),
					fontSize: 11,
					fontWeight: 600,
					style: {
						fill: s.foreground,
						fillOpacity: .78
					}
				}), l.push(...Fr(a, t, i));
			}
			return {
				kind: "group",
				key: "legend",
				className: "ts-chart__legend",
				ariaHidden: !0,
				children: l
			};
		}
	};
}
function Pr(e, t) {
	if (!e) return {
		offset: 0,
		y: 11
	};
	let a = {
		fontSize: 11,
		fontWeight: 600,
		fontFamily: "sans-serif",
		fontStyle: "normal",
		fontStretch: "normal",
		letterSpacing: 0,
		direction: t.direction ?? "inherit",
		fontScale: 1,
		anchor: n("left", t.direction),
		baseline: "auto"
	}, o = r(i, t.layout?.typography)(e, a), s = t.layout?.measureText?.(e, a) ?? o, c = zr(s) ? s : o, l = Math.max(11, -c.y);
	return {
		offset: l + c.y + c.height + 2,
		y: l
	};
}
function Fr({ colors: e, bounds: t, theme: r, direction: i }, a, o) {
	let s = Or(e), c = kr(s.length, t.width, o), l = [];
	return s.forEach((e, o) => {
		let s = o % c.columns, u = Math.floor(o / c.columns), d = t.x + s * c.itemWidth, f = t.y + 10 + a + u * 19;
		l.push({
			kind: "dot",
			key: `legend-dot:${e.key}`,
			x: d + 4,
			y: f,
			radius: 4,
			style: { fill: e.color }
		}, {
			kind: "label",
			key: `legend-label:${e.key}`,
			x: d + 13,
			y: f,
			text: e.label,
			anchor: n("left", i),
			baseline: "middle",
			fontSize: 11,
			style: {
				fill: r.foreground,
				fillOpacity: .76
			}
		});
	}), l;
}
function Ir(e, t, a) {
	let o = e.label, s = e.indicator, c = Q(o?.fontSize, 11), l = Number.isFinite(o?.fontWeight) ? o?.fontWeight : void 0, u = Q(s?.width, 8), d = Q(s?.height, 8), f = Q(s?.gap, 5), p = Q(e.rowGap, 8), m = Or(t.colors, o?.format), h = r(i, t.layout?.typography), g = d / 2, _ = d / 2, v = m.map((e, r) => {
		let i = {
			color: e.color,
			index: r,
			label: e.label
		}, a = {
			fontSize: c,
			fontWeight: l,
			fontFamily: "sans-serif",
			fontStyle: "normal",
			fontStretch: "normal",
			letterSpacing: 0,
			direction: t.direction ?? "inherit",
			fontScale: 1,
			anchor: n("left", t.direction),
			baseline: "middle"
		}, o = h(e.label, a), s = t.layout?.measureText?.(e.label, a) ?? o, d = zr(s) ? s : o;
		return g = Math.max(g, -d.y, 0), _ = Math.max(_, d.y + d.height, 0), {
			...e,
			context: i,
			textX: d.x,
			width: u + f + d.width
		};
	}), y = g + _ + p, b = Math.max(10, g), x = e.justify ?? "stretch";
	if (x === "stretch") {
		let e = kr(v.length, t.bounds.width, a);
		return {
			rows: e.rows,
			rowHeight: y,
			firstRowBaseline: b,
			indicatorWidth: u,
			indicatorHeight: d,
			indicatorGap: f,
			fontSize: c,
			fontWeight: l,
			items: v.map((t, n) => ({
				item: t,
				row: Math.floor(n / e.columns),
				width: e.itemWidth,
				x: n % e.columns * e.itemWidth
			}))
		};
	}
	let S = Ar(v.map((e) => e.width), t.bounds.width, Q(e.gap, 16), x);
	return {
		rows: S.rows,
		rowHeight: y,
		firstRowBaseline: b,
		indicatorWidth: u,
		indicatorHeight: d,
		indicatorGap: f,
		fontSize: c,
		fontWeight: l,
		items: S.items.map(({ index: e, row: t, width: n, x: r }) => ({
			item: v[e],
			row: t,
			width: n,
			x: r
		}))
	};
}
function Lr(e, t, n, r, i) {
	if (e?.render) {
		let i = e.render(t, {
			...n,
			bounds: r
		});
		return "kind" in i ? [i] : i;
	}
	let o = Rr(e?.shape, t, n, "dot"), s = r.x + r.width / 2, c = r.y + r.height / 2, l = Math.min(r.width, r.height);
	if (o === "square") return [{
		kind: "rect",
		key: `legend-square:${a(t)}`,
		x: s - l / 2,
		y: c - l / 2,
		width: l,
		height: l,
		style: { fill: n.color }
	}];
	if (o === "line" || o === "line-dot") {
		let e = [{
			kind: "rule",
			key: `legend-line:${a(t)}`,
			x1: r.x,
			x2: r.x + r.width,
			y1: c,
			y2: c,
			style: {
				stroke: n.color,
				strokeWidth: 3
			}
		}];
		if (o === "line-dot") {
			let r = Math.min(4, l / 2);
			e.push({
				kind: "dot",
				key: `legend-line-dot:${a(t)}`,
				x: s,
				y: c,
				radius: r,
				style: {
					fill: i === "transparent" ? "Canvas" : i,
					stroke: n.color,
					strokeWidth: Math.min(2, r)
				}
			});
		}
		return e;
	}
	return [{
		kind: "dot",
		key: `legend-dot:${a(t)}`,
		x: s,
		y: c,
		radius: l / 2,
		style: { fill: n.color }
	}];
}
function Rr(e, t, n, r) {
	return typeof e == "function" ? e(t, n) : e ?? r;
}
function Q(e, t) {
	return typeof e == "number" && Number.isFinite(e) ? Math.max(0, e) : t;
}
function zr(e) {
	return Number.isFinite(e.x) && Number.isFinite(e.y) && Number.isFinite(e.width) && e.width >= 0 && Number.isFinite(e.height) && e.height >= 0;
}
function Br(e) {
	return e === "continuous";
}
function Vr(e) {
	return e === "quantile" || e === "quantize" || e === "threshold";
}
function Hr(e) {
	return Br(e) || Vr(e);
}
function Ur(e, { colors: t, bounds: r, theme: i, direction: a }) {
	let o = Math.min(r.width, Math.max(80, e.width ?? 240)), s = r.x, c = r.y + (e.label ? 20 : 7), l = o / Math.max(1, t.range.length), u = e.format ?? ((e) => String(e)), d = [];
	e.label && d.push({
		kind: "label",
		key: "legend-label",
		x: s,
		y: r.y + 10,
		text: e.label,
		anchor: n("left", a),
		fontSize: 11,
		fontWeight: 600,
		style: {
			fill: i.foreground,
			fillOpacity: .78
		}
	}), t.range.forEach((e, t) => {
		d.push({
			kind: "rect",
			key: `legend-step:${t}`,
			x: s + t * l,
			y: c,
			width: l + .5,
			height: 8,
			style: { fill: e }
		});
	});
	let f = Wr(t), p = t.domain[0], m = t.domain.at(-1);
	return (t.kind === "threshold" ? f.map((e, t) => ({
		value: e,
		index: t + 1,
		side: "middle"
	})) : [
		...typeof p == "number" ? [{
			value: p,
			index: 0,
			side: "left"
		}] : [],
		...f.map((e, t) => ({
			value: e,
			index: t + 1,
			side: "middle"
		})),
		...typeof m == "number" ? [{
			value: m,
			index: t.range.length,
			side: "right"
		}] : []
	]).forEach(({ value: e, index: t, side: r }) => {
		d.push({
			kind: "label",
			key: `legend-step-label:${t}:${e}`,
			x: s + t * l,
			y: c + 21,
			text: u(e),
			anchor: n(r, a),
			fontSize: 10,
			style: {
				fill: i.muted,
				fillOpacity: .72
			}
		});
	}), {
		kind: "group",
		key: "legend",
		className: "ts-chart__legend ts-chart__legend--stepped",
		ariaHidden: !0,
		children: d
	};
}
function Wr(e) {
	if (e.thresholds) return e.thresholds.filter(Number.isFinite);
	let t = e.domain.filter((e) => typeof e == "number" && Number.isFinite(e));
	if (e.kind === "threshold") return t;
	let n = t.slice().sort((e, t) => e - t), r = n[0], i = n.at(-1);
	if (r === void 0 || i === void 0) return [];
	let a = e.range.length;
	return e.kind === "quantize" ? Array.from({ length: Math.max(0, a - 1) }, (e, t) => r + (i - r) * (t + 1) / a) : e.kind === "quantile" ? Array.from({ length: Math.max(0, a - 1) }, (e, t) => Gr(n, (t + 1) / a)).filter(Number.isFinite) : [];
}
function Gr(e, t) {
	let n = e.length;
	if (n === 0) return NaN;
	if (t <= 0 || n < 2) return e[0] ?? NaN;
	if (t >= 1) return e[n - 1] ?? NaN;
	let r = (n - 1) * t, i = Math.floor(r), a = e[i] ?? NaN;
	return a + ((e[i + 1] ?? a) - a) * (r - i);
}
function Kr(e = {}) {
	return {
		placement: e.placement,
		height() {
			return e.label ? 55 : 42;
		},
		render({ colors: t, bounds: r, theme: i, direction: a }) {
			let o = t.domain[0], s = t.domain.at(-1);
			if (typeof o != "number" || typeof s != "number") throw TypeError("A gradient legend requires a numeric color-scale domain");
			let c = Math.max(2, Math.floor(e.steps ?? 32)), l = Math.min(r.width, Math.max(80, e.width ?? 240)), u = r.x, d = r.y + (e.label ? 20 : 7), f = l / c, p = e.format ?? ((e) => String(e)), m = [];
			e.label && m.push({
				kind: "label",
				key: "legend-label",
				x: u,
				y: r.y + 10,
				text: e.label,
				anchor: n("left", a),
				fontSize: 11,
				fontWeight: 600,
				style: {
					fill: i.foreground,
					fillOpacity: .78
				}
			});
			for (let e = 0; e < c; e += 1) {
				let n = e / (c - 1), r = o + (s - o) * n;
				m.push({
					kind: "rect",
					key: `legend-gradient:${e}`,
					x: u + e * f,
					y: d,
					width: f + .5,
					height: 8,
					style: { fill: t.map(r) }
				});
			}
			return m.push({
				kind: "label",
				key: "legend-gradient:min",
				x: u,
				y: d + 21,
				text: p(o),
				anchor: n("left", a),
				fontSize: 10,
				style: {
					fill: i.muted,
					fillOpacity: .72
				}
			}, {
				kind: "label",
				key: "legend-gradient:max",
				x: u + l,
				y: d + 21,
				text: p(s),
				anchor: n("right", a),
				fontSize: 10,
				style: {
					fill: i.muted,
					fillOpacity: .72
				}
			}), {
				kind: "group",
				key: "legend",
				className: "ts-chart__legend ts-chart__legend--gradient",
				ariaHidden: !0,
				children: m
			};
		}
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scales/intern.js
function qr(e) {
	return e instanceof Date ? `date:${e.getTime()}` : `${typeof e}:${String(e)}`;
}
function Jr(e) {
	let t = [], n = /* @__PURE__ */ new Map();
	for (let r of e) {
		let e = qr(r);
		n.has(e) || (n.set(e, t.length), t.push(r));
	}
	return {
		domain: t,
		index: n
	};
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scales/band-kernel.js
function Yr(e, t, n) {
	let r = [], i = /* @__PURE__ */ new Map(), a = [], o = [0, 1], s = 1, c = +!e, l = !1, u = +!!e, d = 0, f = .5, p = ((e) => {
		let t = i.get(qr(e));
		return t === void 0 ? void 0 : a[t];
	}), m = () => {
		let e = r.length, t = o[1] < o[0], n = t ? o[1] : o[0], i = t ? o[0] : o[1];
		return s = (i - n) / Math.max(1, e - u + d * 2), l && (s = Math.floor(s)), n += (i - n - s * (e - u)) * f, c = s * (1 - u), l && (n = Math.round(n), c = Math.round(c)), a = Array.from({ length: e }, (e, t) => n + s * t), t && a.reverse(), p;
	};
	if (p.domain = ((e) => {
		if (e === void 0) return r.slice();
		let t = Jr(e);
		return r = t.domain, i = t.index, m();
	}), p.range = ((e) => e === void 0 ? [...o] : (o = Xr(e), m())), p.rangeRound = (e) => (o = Xr(e), l = !0, m()), p.bandwidth = () => c, p.step = () => s, p.round = ((e) => e === void 0 ? l : (l = !!e, m())), p.padding = ((e) => e === void 0 ? u : (d = $(e), u = Math.min(1, d), m())), p.paddingInner = ((e) => e === void 0 ? u : (u = Math.min(1, $(e)), m())), p.paddingOuter = ((e) => e === void 0 ? d : (d = $(e), m())), p.align = ((e) => e === void 0 ? f : (f = Math.max(0, Math.min(1, $(e))), m())), p.copy = () => Yr(!1, r, o).round(l).paddingInner(u).paddingOuter(d).align(f), e) {
		let e = p;
		e.bandwidth = () => 0, e.padding = p.paddingOuter, e.copy = () => Yr(!0, r, o).round(l).padding(d).align(f), delete e.paddingInner, delete e.paddingOuter;
	}
	return m(), n === void 0 ? t !== void 0 && p.range(t) : p.domain(t).range(n), p;
}
function Xr(e) {
	let t = Array.from(e, $);
	if (t.length !== 2 || t.some((e) => !Number.isFinite(e))) throw TypeError("A scale range requires exactly two finite numbers");
	return [t[0], t[1]];
}
function $(e) {
	return Number(e);
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scales/band.js
function Zr(e, t) {
	return Yr(!1, e, t);
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scales/ticks.js
var Qr = [
	1,
	2,
	5,
	10
];
function $r(e, t, n) {
	if (!(n > 0)) return [];
	if (e === t) return [e];
	let r = t < e, i = ni(r ? t : e, r ? e : t, n);
	return i.lastIndex >= i.firstIndex ? Array.from({ length: i.lastIndex - i.firstIndex + 1 }, (e, t) => si(r ? i.lastIndex - t : i.firstIndex + t, i.interval)) : [];
}
function ei(e, t, n) {
	return ni(e, t, n).interval;
}
function ti(e, t, n) {
	let r = t < e, i = ei(r ? t : e, r ? e : t, n), a = i < 0 ? -1 / i : i;
	return r ? -a : a;
}
function ni(e, t, n) {
	let r = n;
	for (;;) {
		let n = ri(e, t, r), i = ai(e, n), a = oi(t, n);
		if (a >= i || !(r >= .5 && r < 2)) return {
			firstIndex: i,
			lastIndex: a,
			interval: n
		};
		r *= 2;
	}
}
function ri(e, t, n) {
	let r = (t - e) / Math.max(0, n), i = Math.floor(Math.log10(r)), a = 10 ** i, o = ii(r / a);
	return i < 0 ? -(10 ** -i) / o : a * o;
}
function ii(e) {
	let t = Qr[0];
	for (let n of Qr.slice(1)) {
		if (!(e >= Math.sqrt(t * n))) break;
		t = n;
	}
	return t;
}
function ai(e, t) {
	let n = t < 0 ? e * -t : e / t, r = Math.round(n);
	return r < n ? r + 1 : r;
}
function oi(e, t) {
	let n = t < 0 ? e * -t : e / t, r = Math.round(n);
	return r > n ? r - 1 : r;
}
function si(e, t) {
	return t < 0 ? e / -t : e * t;
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scales/linear.js
function ci(e, t) {
	let n = [0, 1], r = [0, 1], i = !1, a = ((e) => {
		if (e != null && Number.isFinite(Number(e))) return li(Number(e), n, r, i);
	});
	return a.domain = ((e) => e === void 0 ? [...n] : (n = ui(e, "domain"), a)), a.range = ((e) => e === void 0 ? [...r] : (r = ui(e, "range"), a)), a.invert = (e) => li(e, r, n, i), a.clamp = ((e) => e === void 0 ? i : (i = !!e, a)), a.ticks = (e = 10) => $r(n[0], n[1], e), a.tickFormat = (e = 10) => {
		let t = Math.abs(ti(n[0], n[1], e)), r = t > 0 && t < 1 ? Math.min(20, Math.max(0, -Math.floor(Math.log10(t)))) : 0;
		return (e) => {
			let t = r ? e.toFixed(r) : String(e);
			return t === "-0" ? "0" : t;
		};
	}, a.nice = (e = 10) => {
		let t = n[0], r = n[1], i = 0, o = 1;
		r < t && ([t, r] = [r, t], [i, o] = [o, i]);
		let s;
		for (let a = 10; a > 0; a--) {
			let a = ei(t, r, e);
			if (a === s) {
				let e = [...n];
				e[i] = t, e[o] = r, n = e;
				break;
			}
			if (a > 0) t = Math.floor(t / a) * a, r = Math.ceil(r / a) * a;
			else if (a < 0) t = Math.ceil(t * a) / a, r = Math.floor(r * a) / a;
			else break;
			s = a;
		}
		return a;
	}, a.copy = () => ci(n, r).clamp(i), t === void 0 ? e !== void 0 && a.range(e) : a.domain(e).range(t), a;
}
function li(e, t, n, r) {
	let i = t[1] - t[0], a = i ? (e - t[0]) / i : .5;
	return r && (a = Math.max(0, Math.min(1, a))), n[0] + a * (n[1] - n[0]);
}
function ui(e, t) {
	let n = Array.from(e, Number);
	if (n.length !== 2 || n.some((e) => !Number.isFinite(e))) throw TypeError(`A linear scale ${t} requires exactly two finite numbers`);
	return [n[0], n[1]];
}
//#endregion
//#region ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/scales/point.js
function di(e, t) {
	return Yr(!0, e, t);
}
//#endregion
//#region src/charts/presets/shared.ts
var fi = (e) => String(e), pi = Dr(ie);
function mi(e) {
	return [...new Set(e.map((e) => e.series))];
}
function hi(e) {
	return e[0]?.x instanceof Date;
}
var gi = Nr({ items: Mr({
	justify: "start",
	gap: 12
}) });
function _i(e, t = {}, n = !0, r) {
	let i = (e, n) => t[e] ?? s[n % s.length], a = (t) => r !== void 0 && e.includes(r) && r !== t;
	return {
		domain: e,
		range: e.map((e, t) => a(e) ? `color-mix(in srgb, ${i(e, t)} 25%, transparent)` : i(e, t)),
		legend: n && e.length > 1 ? gi : void 0
	};
}
function vi(e, t, n) {
	return {
		scale: ci,
		side: n,
		nice: !0,
		grid: !0,
		axis: {
			label: t,
			ticks: { format: e }
		}
	};
}
function yi(t, n, r, i = n === "band" ? .2 : .1) {
	return hi(t) ? {
		scale: Er,
		axis: { ticks: {
			count: 6,
			format: r ?? e
		} }
	} : {
		scale: n === "band" ? () => Zr().padding(i) : () => di().padding(i),
		axis: r ? { ticks: { format: r } } : void 0
	};
}
function bi(t, n, r, i) {
	let a = r ?? (hi(t) ? e : fi);
	return o({
		anchor: "group-center",
		placement: i,
		sort: "color-domain",
		items: [{
			channel: "x",
			label: "",
			text: (e) => a(e.xValue)
		}, {
			channel: "y",
			label: "",
			text: (e) => n(e.yValue)
		}]
	});
}
var xi = {
	x: "x",
	y: "value",
	z: "series",
	color: "series"
};
function Si(e) {
	return Object.fromEntries(e.flatMap((e) => e.color ? [[e.label, e.color]] : []));
}
function Ci(e, n) {
	return o({ content: (r) => ({ rows: r.map((r) => {
		let { label: i, value: a } = r.datum;
		return {
			label: i,
			value: `${e(a)} (${t(a / n)})`,
			color: r.color
		};
	}) }) });
}
//#endregion
export { _e as _, bi as a, c as b, xi as c, vi as d, di as f, Er as g, Nr as h, _i as i, mi as l, Zr as m, Ci as n, hi as o, ci as p, yi as r, fi as s, Si as t, pi as u, _ as v, g as y };

//# sourceMappingURL=shared-D0HMDGlg.js.map